exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".commands {\n  border-bottom: 3px #000000 solid;\n  padding: 10px; }\n  .commands button {\n    margin: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/util-page/util-page.scss
// module id = ../../../../../src/app/admin-area/containers/util-page/util-page.scss
// module chunks = main